import  React , { FC } from "react";
import moment from "moment";

interface DataViewProps {
  data: any;
  type: string;
  viewLimit?: number;
}

export const DataView: FC<DataViewProps> = ({ data, type, viewLimit=0 }) => {
  let showData;
 
  if (data) {
    if (type === 'string') {
    
        if (data?.length > viewLimit) {
          showData = data?.slice(0, viewLimit)+'...';
        } else {
          showData = data;
        }
    
    } else if(type === 'number') {
        showData = data;
    } else if(type === 'date'){
        showData = moment(data).format('DD MMMM, yyyy');
    } else {
        showData = data;
    }
  } else {
     showData = '--'
  }
  return <h5 className="fw-normal m-0 p-0" style={{color:'#667085', fontSize:'13px'}}>{showData}</h5>;
};
